import React, { useState, useEffect, useContext } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { appContext } from '../../App';
import { auth, addToDatabase, onDbChange, detachListener } from '../../firebase/firebase';
import MessageDetails from '../message-list/MessageDetails';
import { lists, lang } from '../../util/constants';

import './message-us.css';

const MessageUs = (props: any) => {
   const [name, setName] = useState('');
   const [nameInput, setNameInput] = useState('');
   const [message, setMessage] = useState('');
   const [isMessageSent, setIsMessageSent] = useState(false);
   const { messages, setMessages, language } = useContext(appContext);
   useEffect(() => {
      auth.onAuthStateChanged(user => {
         if (user) {
            onDbChange(setMessages);
            return () => {
               detachListener();
            }
         }
      });
   }, [])

   function nameOnChange(e: React.ChangeEvent<HTMLInputElement>) : void {
      setNameInput(e.target.value);
   }

   function handleSendClick() : void {
      const data = {
         status: lists.unchecked,
         name: nameInput,
         message,
         date: Date.now()
      }
      addToDatabase(data, setIsMessageSent, true);
      setName(nameInput);
      setIsMessageSent(true);
      setMessage('');
      setNameInput('');
   }
   
   return (
      <div className='mu-container padd' id='mu-container'>
         <div className='mu'>
            <h2>{language === lang.pt ? 'Gostaria de nos deixar uma mensagem?' : 'Would you like to leave us a message?'}</h2>
            <div className='mu-inputs'>
               {
                  isMessageSent &&
                  <div className='message-sent d-flex flex-column justify-content-center align-items-center'>
                     <div className='ms-close' onClick={() => setIsMessageSent(false)}><AiOutlineClose /></div>
                     <div>{language === lang.pt ? 'Obrigado pela sua mensagem' : 'Thank you for the message'}, {name}!</div>
                     <div>
                        {
                           language === lang.pt ?
                           'Nós iremos ler e postá-la abaixo' :
                           'We are going to post it below as soon as we read it'
                        }
                     </div>
                  </div>
               }
               <input 
                  type='text' 
                  placeholder={language === lang.pt ? 'Nome' : "Name"}
                  value={nameInput} 
                  onChange={e => nameOnChange(e)}
               />
               <textarea 
                  placeholder={language === lang.pt ? 'Mensagem' : "Message"} 
                  value={message} 
                  onChange={e => setMessage(e.target.value)}
               ></textarea>

               <div className='send-msg'>
                  <button 
                     className='send-button btn btn-success'
                     onClick={handleSendClick}
                     disabled={!nameInput || !message}
                     style={!nameInput || !message ? {cursor: 'not-allowed'} : {}}
                  >
                     {language === lang.pt ? 'Enviar' : "Send"}
                  </button>
               </div>
            </div>

            <div className='message-list-container'>
               {
                  messages &&
                  messages.filter(message => message.status === lists.approved).map((msg: any) => {
                     return (
                        <MessageDetails key={msg.date} msg={msg} language={language} lang={lang}/>
                     );
                  })
               }
            </div>
         </div>
      </div>
   )
}

export default MessageUs
